import { useCallback } from 'react'
import { TransactionResponse } from '@ethersproject/providers'
import { getClaimAllContract } from '~/contracts/getClaimAllContract'
import { useWallet } from './useWallet'

interface ClaimAllParams {
	index: number
	proofs: string[]
	amount: string
	account: string
}

export function useClaimAll() {
	const wallet = useWallet()

	return useCallback(
		async ({
			index,
			account,
			amount,
			proofs,
		}: ClaimAllParams): Promise<TransactionResponse> => {
			await wallet.web3.ready

			const contract = getClaimAllContract(wallet.web3).connect(
				wallet.web3.getSigner(wallet.account)
			)

			return contract.claim(index, account, amount, proofs)
		},
		[wallet]
	)
}
